import { OfferOptionUrlConstant } from 'src/constants';
import {
  OfferOptionDto,
  CreateOfferOptionDto,
  GetOfferOptionListDto,
  GetOfferOptionDto,
  PatchOfferOptionDto,
  DeleteOfferOptionDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class OfferOptionsApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async create({ params, body }: CreateOfferOptionDto): Promise<OfferOptionDto> {
    const url = replacePlaceholders(OfferOptionUrlConstant.CREATE, params);

    return httpRequest<OfferOptionDto>({
      method: 'POST',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async list({ params }: GetOfferOptionListDto): Promise<OfferOptionDto[]> {
    const url = replacePlaceholders(OfferOptionUrlConstant.LIST, params);

    return httpRequest<OfferOptionDto[]>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async retrieve({ params }: GetOfferOptionDto): Promise<OfferOptionDto> {
    const url = replacePlaceholders(OfferOptionUrlConstant.RETRIEVE, params);

    return httpRequest<OfferOptionDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async patch({ params, body }: PatchOfferOptionDto): Promise<OfferOptionDto> {
    const url = replacePlaceholders(OfferOptionUrlConstant.PATCH, params);

    return httpRequest<OfferOptionDto>({
      method: 'PATCH',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async delete({ params }: DeleteOfferOptionDto): Promise<void> {
    const url = replacePlaceholders(OfferOptionUrlConstant.DELETE, params);

    await httpRequest<OfferOptionDto>({
      method: 'DELETE',
      url,
      authToken: this._configService.authToken,
    });
  }
}
